<template>
  <div class="camp1path1" v-if="path == 1">

    <div class="path">
        
        <div :class="openedTile !== 0 ? 'step-content open' : 'step-content'">

            <a v-if="openedTile !== 0" class="back-to-list" @click="closeTile()"><span>&lt;</span> Back to the list</a>

            <a v-if="openedTile === 0" class="close" @click="voidPath()"><span>x</span></a>

            <ul v-if="openedTile === 0" :class="('nav step' + step)">
                <li><a class="step1" @click="goto(1)">Setting the Table <span :class="(getProgress(1) + 'progress p'+ progress1)"></span></a></li>
                <li><a class="step2" @click="goto(2)">Governance <span :class="(getProgress(2) + 'progress p'+ progress2)"></span></a></li>
                <li><a class="step3" @click="goto(3)">Vision & Values <span :class="(getProgress(3) + 'progress p'+ progress3)"></span></a></li>
                <li><a class="step4" @click="goto(4)">Leadership <span :class="(getProgress(4) + 'progress p'+ progress4)"></span></a></li>
                <li><a class="step5" @click="goto(5)">Financing <span :class="(getProgress(5) + 'progress p'+ progress5)"></span></a></li>
            </ul>

            <div v-if="step == 1">
                <h1 v-if="(openedTile === 0)">Setting the Table</h1>
                
                <ul class="progress-line">
                    <li :class="statusClass('1.1')">
                        <span class="item-number">1</span>
                        <div v-if="!isOpened('1.1')" class="preview" @click="showTile('1.1')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/3CM.jpg'" alt="3 circle model">
                            </div>
                            <div class="description">
                                <strong>Understand the 3 circle model</strong> <!--The Three-Circle Model is a framework that has proven to be useful in increasing our understanding of family businesses. Three domains are present: family, business, and ownership. To illustrate how these three domains interact we need to have them overlap with one another. Through this lens we can see the forces that are in play most of the time in a positive and competing manner. -->
                            </div>
                        </div>
                        <div v-if="isOpened('1.1')" class="item-content">
                            <three-circle-model model="c1p1s1t1" />

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/pdf/Article-How-Three-Circles-Changed-the-Way-We-See-Family-Business.pdf'" target="_blank">How Three Circles Changed the Way We Understand Family Business</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous hide"></a>
                                <a class="next" @click="showTile('1.2')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('1.2')">
                        <span class="item-number">2</span>
                        <div v-if="!isOpened('1.2')" class="preview" @click="showTile('1.2')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/3CM.jpg'" alt="3 circle model">
                            </div>
                            <div class="description">
                                <strong>The 7 territories</strong> <!--As a family business member, you may be in more than one circle at a given time, but you can only be in one of the 7 territories shown here. All 7 territories offer a unique perspective and may influence someone's viewpoint about an issue. Keep this in mind it may help you better understand some of your family members opinions.-->
                            </div>
                        </div>
                        <div v-if="isOpened('1.2')" class="item-content">
                            <three-circle-model model="c1p1s1t2" />

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/pdf/Article-How-Three-Circles-Changed-the-Way-We-See-Family-Business.pdf'" target="_blank">How Three Circles Changed the Way We Understand Family Business</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('1.1')">Previous</a>
                                <a class="next" @click="showTile('1.3')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('1.3')">
                        <span class="item-number">3</span>
                        <div v-if="!isOpened('1.3')" class="preview" @click="showTile('1.3')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/life-cycle.jpg'" alt="Understanding personal life-cycles">
                            </div>
                            <div class="description">
                                <strong>Understanding personal life-cycles</strong> <!--When you take a step back and look at all the life cycles that are in play simultaneously no wonder the dynamics of family business are complex. All these cycles have an influence on you, your family and your business.-->
                            </div>
                        </div>
                        <div v-if="isOpened('1.3')" class="item-content">
                            <three-circle-model model="c1p1s1t3" />

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="link"><a href="https://familyenterprise.ca/resource/interfacing-lifecycle-imply-constant-change/" target="_blank">Interfacing Lifecycle Imply Constant Change</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('1.2')">Previous</a>
                                <a class="next" @click="showTile('1.4')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('1.4')">
                        <span class="item-number">4</span>
                        <div v-if="!isOpened('1.4')" class="preview" @click="showTile('1.4')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/whoisfamily.jpg'" alt="Who is Family?">
                            </div>
                            <div class="description">
                                <strong>Who is Family?</strong> <!--Who is Family? A question that hits at the heart of business families. There is no universal answer as all families have unique situations and ways of being more, or less, inclusive. In this era of changing family definitions, it's important to understand who you and your family view as family. Dive into our assessment and discover who is family to you.-->
                            </div>
                        </div>
                        <div v-if="isOpened('1.4')" class="item-content">
                            

                            <who-is-family />


                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="link"><a href="https://familyenterprise.ca/resource/participation-of-in-laws-in-family-meetings-and-decision-processes/" target="_blank">Participation of In-Laws in Family Meetings and Decision Processes</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('1.3')">Previous</a>
                                <a class="next" @click="showTile('1.5')">Next</a>
                            </div>
                        </div>
                        
                    </li>
                    <li :class="statusClass('1.5')">
                        <span class="item-number">5</span>
                        <div v-if="!isOpened('1.5')" class="preview" @click="showTile('1.5')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/genogram.jpg'" alt="Map out Family Genogram">
                            </div>
                            <div class="description">
                                <strong>Map out Family Genogram</strong> <!--The Genogram is an interesting way to draw your family legacy, it can illustrate the past, the present, and sometimes even give you a glimpse of the future. Genograms can reveal a wealth of knowledge about your family. Build your family genogram!-->
                            </div>
                        </div>
                        <div v-if="isOpened('1.5')" class="item-content">
                            
                            <a href="https://familyenterprise.ca/resources/compass/?c=10" target="_blank" class="play-link">
                                <span>Click to complete your genogram</span>
                                <img :src="baseurl + 'assets/images/genogram-preview.jpg'" alt="Genogram" style="max-width: 80%; height: auto; margin-left: auto; margin-right: auto; display: block;">
                            </a>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('1.4')">Previous</a>
                                <a class="next" @click="showTile('1.6')">Next</a>
                            </div>
                        </div>
                        
                    </li>

                    <li :class="statusClass('1.6')">
                        <span class="item-number">6</span>
                        <div v-if="!isOpened('1.6')" class="preview" @click="showTile('1.6')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/purpose.jpg'" alt="Sibling Partnership">
                            </div>
                            <div class="description">
                                <strong>Sibling Partnership</strong> <!--As you prepare for your family transition, it's important to understand that, most of the time, the family, business, and ownership assets are passed down to not one person, but a sibling partnership. This can create wonderful opportunities and also new challenges-->
                            </div>
                        </div>
                        <div v-if="isOpened('1.6')" class="item-content">
                            <iframe src="https://player.vimeo.com/video/104546428?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="link"><a href="https://familyenterprise.ca/resource/margaret-jean-mannix-next-gen-ownership-among-siblings-and-cousins/" target="_blank">Margaret-Jean Mannix: Next Gen Ownership among Siblings and Cousins</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('1.5')">Previous</a>
                                <a class="next" @click="nextStep(); showTile('2.1')">Next</a>
                            </div>
                        </div>
                        
                    </li>
                </ul>
            </div>









            <div v-if="step == 2">
                <h1 v-if="openedTile === 0">Clarifying the Goals and Priorities</h1>
                
                <ul class="progress-line">
                    <li :class="statusClass('2.1')">
                        <span class="item-number">1</span>
                        <div v-if="!isOpened('2.1')" class="preview" @click="showTile('2.1')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo94587604.jpg'" alt="Goals of Family Governance">
                            </div>
                            <div class="description">
                                <strong>Goals of Family Governance</strong> <!--You understand the needs and wants of the family, and the next step is setting up the right governance structures. Family governance is one of the most critical factors needed for any successful family enterprise to achieve a successful continuity plan. -->
                            </div>
                        </div>
                        <div v-if="isOpened('2.1')" class="item-content">
                            <div class="block">
                                <h1>Goals of Family Governance</h1>
                                <div class="res-date">Published: Feb 22, 2022</div>
    
                                <p>You understand the needs and wants of the family, and the next step is setting up the right governance structures. Family governance is one of the most critical factors needed for any successful family enterprise to achieve a successful continuity plan.&nbsp; The first point I want to make about Family Governance is, watch your narrative.&nbsp;</p>

                                <p>Are you telling your family we <strong>should</strong> have a family governance structure because it’s what you’re hearing, and that the “buzz” is that all good family enterprise families have it in place? Are your advisors pushing you forward to have a family constitution and you are leaving it to them to create this document?</p>

                                <p>Are you putting energy into something you think is complex, and is approached with frustration?</p>

                                <p>Family governance is not overly complicated once you understand the purpose and intent. It is not something to be created without the input and clarity of the family members themselves.&nbsp;And it is not something to be approached with a “we should have it”, because we read about it somewhere.&nbsp;</p>

                                <p>Let’s start with “what governance is?” In a nutshell, governance is a system to help you make better decisions.&nbsp; As a family you already make decisions together. To document your family governance is to bring awareness to how you already make decisions.&nbsp; Then expand by asking “What’s been working for us and what hasn’t, and what changes do we want to see in how we make decisions better together?”</p>

                                <p>The first step is to come together and have intentional conversations on exactly this topic.&nbsp; Take the stigma away that governance is a very structured, bureaucratic, costly endeavour.&nbsp; Focus more on saying “Let’s document what works for us as a family in making decisions together.” You may want to use how you went about organizing your parents 25<sup>th</sup> anniversary or Grandpa’s 80<sup>th</sup> birthday.&nbsp; What about the last holiday you took together, how did that come about?&nbsp; When you break down what you’ve already done, the base of your family governance is likely already all there.</p>

                                <p>The top goal of having family governance is to have a shared vision and set of values you all agree are the core of your family.&nbsp; In communicating and documenting together on this topic, you will come to discover the glue that keeps your family together.&nbsp; For some families just speaking about it is enough.&nbsp; For others, they create a family motto or mission statement that becomes the family’s guiding star; to query are they meeting all that is in this statement when coming together to make a family decision.&nbsp; If your family is ready to adopt more structure in your governance, you may begin with family meetings, set up committees to discuss and recommend decisions, form a family council to co-ordinate voting and execution, and create a formal Family Constitution.&nbsp; There is no one set of rules that you must focus on what is best for your family, so each family can customize the definition of the right governance for them.</p>

                                <p>You may want to begin with creating a vision statement on what family governance means to you: a written document, a set of policies, a one line statement, an understood agreement, and then set out on a process to achieve what works for you as a family.&nbsp; Some families can embark on this journey alone, others have a family champion who steers them forward and others reach out to a skilled advisor who guilds them down this process.</p>

                                <p>If you are at the stage where you are asking “Do we already have Family Governance Structures in place?” you may want to consider the following:</p>

                                <ul>
                                    <li>What does wealth mean</li>
                                    <li>Family vision</li>
                                    <li>Family values</li>
                                    <li>Family meetings</li>
                                    <li>Family council</li>
                                    <li>Family assembly</li>
                                    <li>Family office</li>
                                    <li>Independent board of directors</li>
                                    <li>Philanthropic board/intent.</li>
                                </ul>

                                <p>To be set with Family Governance, you may have one or all of the above.&nbsp; Do what is right for your family, and set your goals appropriately. The goal of Family Governance is not focused on financial wealth.&nbsp; The goal is family harmony, unity, and keeping the family engaged.&nbsp; The focus is on family relationships and learning and developing together.&nbsp; It’s about empowering the next generation and giving voice to all family members.&nbsp; It’s important to take the perspective of planning <em>with </em>the family rather than <em>for </em>the family.</p>

                                <p>“Families better the odds of successful continuity through regular structured dialogue – one conversation at &nbsp;a time.” Do you have Family Governance in Place?</p>

                                <p>If you are looking for further readings on governance check these out:</p>

                                <ul>
                                    <li>When having too many experts on the board backfires, Tilcsik &amp; Almandoz, HBR</li>
                                    <li>How to be a good board chair, Shekshnia, HBR</li>
                                    <li>Range: Why Generalists Triumph in a Specialized World, Epstein, 2019</li>
                                    <li><a href="http://www.rotman.utoronto.ca/Johnston" target="_blank">David &amp; Sharon Johnston Centre for Corporate Governance Innovation</a></li>
                                </ul>

                                <p><strong>Decision Tree Question: Do You Have Family Governance in Place?</strong></p>

                                <p>Listen to Dr. Lee Hausner and Mitchell Taylor discuss the importance of a governance system in a family business. In a family business, it is important to hold family meetings to discuss both the opportunities and challenges of the business, and to assign clear roles and responsibilities to family members. Having consistent family meetings will help ensure the organization and success of a family business.</p>

                                <iframe src="https://player.vimeo.com/video/94587604?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe>
                            </div>  

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="previousStep(); showTile('1.6')">Previous</a>
                                <a class="next" @click="showTile('2.2')">Next</a>
                            </div>
  
                        </div>
                    </li>
                    <li :class="statusClass('2.2')">
                        <span class="item-number">2</span>
                        <div v-if="!isOpened('2.2')" class="preview" @click="showTile('2.2')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/how-do-you-make-decisions.jpg'" alt="How are information or key decisions disseminated?">
                            </div>
                            <div class="description">
                                <strong>How are information or key decisions disseminated?</strong> <!--Time to make your personal diagnosis on how decisions are made in the family. Take a moment to evaluate how you make decisions in your family-->
                            </div>
                        </div>
                        <div v-if="isOpened('2.2')" class="item-content">
                            
                            <a href="https://familyenterprise.ca/resources/compass/?c=56" target="_blank" class="play-link">
                                <span>Click to complete the assessment</span>
                                <img :src="baseurl + 'assets/images/slide56.jpg'" alt="Slide 56" style="max-width: 80%; height: auto; margin-left: auto; margin-right: auto; display: block;">
                            </a>


                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="link"><a href="https://familyenterprise.ca/resource/making-decisions-in-an-ever-changing-world/" target="_blank">Making Decisions in an Ever-Changing World</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('2.1')">Previous</a>
                                <a class="next" @click="showTile('2.3')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('2.3')">
                        <span class="item-number">3</span>
                        <div v-if="!isOpened('2.3')" class="preview" @click="showTile('2.3')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/ed3.jpg'" alt="What Should We Talk About at Family Meetings?">
                            </div>
                            <div class="description">
                                <strong>What Should We Talk About at Family Meetings?</strong> <!--Family meetings are the core of a family’s governance. It’s a team effort where all members should play a role and have a say. Getting together regularly can lead to tremendous improvements in communication and open discussions about family purpose, values and vision. Discover how to conduct effective family meetings with our case-based assessment.-->
                            </div>
                        </div>
                        <div v-if="isOpened('2.3')" class="item-content">
                            <a href="https://familyenterprise.ca/resources/ed3/" target="_blank" class="play-link">
                                <span>Click to complete the assessment</span>
                                <img :src="baseurl + 'assets/images/ed3-preview.jpg'" alt="What Should We Talk About at Family Meetings" style="max-width: 80%; height: auto; margin-left: auto; margin-right: auto; display: block;">
                            </a>


                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('2.2')">Previous</a>
                                <a class="next" @click="showTile('2.4')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('2.4')">
                        <span class="item-number">4</span>
                        <div v-if="!isOpened('2.4')" class="preview" @click="showTile('2.4')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo62108551.jpg'" alt="What is a Family Council?">
                            </div>
                            <div class="description">
                                <strong>What is a Family Council?</strong> <!--A Family Council is a leadership and governance forum that exists to help an enterprising family achieve its mission and important goals by way of these activities: Create compelling family values, mission, and vision statements, which clarify the family's important principles, purpose, direction, and key objectives.-->
                            </div>
                        </div>
                        <div v-if="isOpened('2.4')" class="item-content">
                            
                            <div class="block">
                                <h1>Effective Family Councils and Family Forums</h1>
                                <div class="res-author">Mitchell Taylor, Clinton Taylor, Roger Reidy</div>
                                <div class="res-date">Published: Nov 19, 2012</div>
                                
                                <p>Listen to the Taylors, a 3rd generation winemaking business family operating Taylor Wines based in Clare Valley, Australia, describe how their inclusive family governance mechanisms, such as family meetings and forums, enable them to communicate effectively and avoid major conflict. </p>

                                <p><em>(Taylor Wines are known as Wakefield Wines in the northern hemisphere due to trademark restrictions)</em></p>

                                <iframe src="https://player.vimeo.com/video/62108551?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe>

                                <div class="additional-resources">
                                    <h3>Additional Resources</h3>
                                    <ul>
                                        <li class="pdf"><a :href="baseurl + 'assets/pdf/family/Family-Council.pdf'" target="_blank">Family Council Structure</a></li>
                                    </ul>
                                </div>

                                <div :class="'nav nav'+path">
                                    <a class="previous" @click="showTile('2.3')">Previous</a>
                                    <a class="next" @click="showTile('2.5')">Next</a>
                                </div>

                            </div>
                        </div>
                        
                    </li>
                    <li :class="statusClass('2.5')">
                        <span class="item-number">5</span>
                        <div v-if="!isOpened('2.5')" class="preview" @click="showTile('2.5')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/topography-family-meetings.jpg'" alt="Topography for Family Meetings & Councils">
                            </div>
                            <div class="description">
                                <strong>Topography for Family Meetings & Councils</strong> <!--Family meetings & councils need to be well prepared. Here is a step by step guide to help you hold effective and efficient family meetings & councils.-->
                            </div>
                        </div>
                        <div v-if="isOpened('2.5')" class="item-content">
                            
                            <a href="https://familyenterprise.ca/resources/compass/?c=58" target="_blank" class="play-link">
                                <span>Click here for a Planning Family Meeting template</span>
                                <img :src="baseurl + 'assets/images/slide58.jpg'" alt="Slide 58" style="max-width: 80%; height: auto; margin-left: auto; margin-right: auto; display: block;">
                            </a>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/pdf/family/Planning-A-Family-Meeting.pdf'" target="_blank">Planning Family Meetings & Councils</a></li>
                                    <li class="link"><a href="https://familyenterprise.ca/resource/four-cornerstones-to-family-meetings-2/" target="_blank">Four Cornerstones to Family Meetings</a></li>
                                    <li class="link"><a href="https://familyenterprise.ca/resource/family-governance-ffla/" target="_blank">Family Governance (FFLA)</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('2.4')">Previous</a>
                                <a class="next" @click="showTile('2.6')">Next</a>
                            </div>
                        </div>
                        
                    </li>

                    <li :class="statusClass('2.6')">
                        <span class="item-number">6</span>
                        <div v-if="!isOpened('2.6')" class="preview" @click="showTile('2.6')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo260832018.jpg'" alt="Proactively anticipate and address where potential conflict might arise in executing the plan.">
                            </div>
                            <div class="description">
                                <strong>Proactively anticipate and address where potential conflict might arise in executing the plan. </strong> <!--Family conflict is normal and, in many ways, to be expected. However, it is how you deal and resolve the conflict that should really be the focus. Explore these resources and refelct on what is your best startegy for managing family conflict.-->
                            </div>
                        </div>
                        <div v-if="isOpened('2.6')" class="item-content">
                            
                            <iframe src="https://player.vimeo.com/video/260832018?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="link"><a href="https://familyenterprise.ca/resource/harnessing-conflict/" target="_blank">Harnessing Conflict</a></li>
                                    <li class="link"><a href="https://familyenterprise.ca/resource/managing-conflict-in-family-business/" target="_blank">Managing Conflict in Family Business</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('2.5')">Previous</a>
                                <a class="next" @click="nextStep(); showTile('3.1')">Next</a>
                            </div>

                        </div>
                        
                    </li>
                </ul>
            </div>




            <div v-if="step == 3">
                <h1 v-if="openedTile === 0">Reviewing (or Defining) Familiy Strategy</h1>
                
                <ul class="progress-line">
                    <li :class="statusClass('3.1')">
                        <span class="item-number">1</span>
                        <div v-if="!isOpened('3.1')" class="preview" @click="showTile('3.1')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vision.jpg'" alt="Vision, Mission, and Values">
                            </div>
                            <div class="description">
                                <strong>Vision, Mission, and Values</strong> <!--All members of the family have a hand in articulating these values and all agree to live them. Coming together to articulate your family vision mission and values is a great journey for the family to embark on.-->
                            </div>
                        </div>
                        <div v-if="isOpened('3.1')" class="item-content">
                            <div class="block">
                                <h1>Vision, Mission and Values</h1>
                                <div class="res-date">Published: Feb 21, 2022</div> 

                                <p>You’ve determined you are a Family Enterprise. You see a need for a liquidity event down the road, or have gone through some form of liquidity event for your family enterprise. It sounds like you’ve decided what the liquidity will be used for.&nbsp; Now you are at the point to share the vision with your family. Why is this important?</p>

                                <p>Having a very clear vision gives you a purpose for moving forward, especially in the hardship of working your continuity planning. A family mission statement encapsulates your idea of a good life and lays out your family’s purpose, goals and standards.&nbsp; All members of the family have a hand in articulating these values and all agree to live them.&nbsp; Coming together to articulate your family vision mission and values is a great journey for the family to embark on. The journey gives you a shared experience that, in itself, bonds the family closer together.&nbsp; This is a true case where the journey is much more valuable than the destination itself.</p>

                                <p>Some families choose the journey that leads to a documented family constitution.&nbsp; This document codifies the vision and dreams of the family. Building a constitution together gives the family a process to embark on together that encourages communication. The constitution becomes the moral agreement for all family members and is a great tool to forward if the family has a multigenerational intent.&nbsp; The constitution defines how you agree to communicate with each other, it defines how you deal with differences and may outline conflict management tools.&nbsp; It documents how you make decisions and is the structure for you family governance.</p>

                                <p>Coming together as a family to build on this creates a bond between family members. Your family’s sense of unity and purpose strengthens when every member knows that everyone is truly committed to each other’s success and growth.</p>

                                <p>Some questions to ask each other in creating your family’s vision are:</p>

                                <ol type="1">
                                    <li>What character qualities do we want to instill in our children?</li>
                                    <li>What are some practical applications and activities we can do as a family to help cultivate the vision?</li>
                                    <li>How do we plan on communicating the vision to our children?</li>
                                    <li>What are rules we can set up to guide the family vision?</li>
                                </ol>

                                <p>As a family, when you’ve taken the time to open the conversation on your shared vision, mission and values you’ve brought yourself closer to making decision in consensus.&nbsp; There are great advantages when you can come together as a family with consensus.&nbsp; It builds unity, maintains unity and requites unity.&nbsp; It also creates listeners and collaborators.</p>

                                <p>When you come together as a family aiming for consensus in your decision making, you achieve all the key attributes to good decision making in a family:</p>

                                <ul>
                                    <li>No surprises</li>
                                    <li>Sincerely care</li>
                                    <li>Mutual commitment</li>
                                    <li>Good conduct</li>
                                </ul>

                                <p>This leads to family unity and harmony within the family. Does your family have a compelling vision that encourages family unity and ensures long-term wealth creation?</p>

                                <p>Other questions to ask as you think about your long-term vision and what your legacy will be are:</p>

                                <ul>
                                    <li>What is your wish for the future?</li>
                                    <li>What is your wish for the family?</li>
                                    <li>What is your wish for the business?</li>
                                    <li>How do you want to be remembered?</li>
                                    <li>Will your legacy be one of closeness or distance?</li>
                                </ul>

                                <p>“Your legacy is not what you leave others… It’s what you give, create and contribute today while you’re here that then happens to live on.” (R. Oganiura)</p>

                                <p>Keep these 10 points in mind if you want to avoid harming your legacy:</p>

                                <ol type="1">
                                    <li>Never ask for input when making decisions that impact your family</li>
                                    <li>Refuse to discuss the reason for the decisions you make</li>
                                    <li>Create competition for your favour between your children</li>
                                    <li>Label family members and encourage other family members to use those labels</li>
                                    <li>Only validate people who remind you of yourself</li>
                                    <li>Decide who you trust based on who agrees with you</li>
                                    <li>Don’t let others find meaning in things you don’t find interesting</li>
                                    <li>Refuse to lead, but make sure everyone knows you are in charge</li>
                                    <li>Don’t talk about personal relationships, feelings and definitely not failures</li>
                                    <li>Ignore your family’s interests while you are alive, but plan on radically impacting their lives after you are dead.</li>
                                </ol>

                                <p>Take the opposite into account when creating your family vision, mission and values.</p>

                                <p>It may seem a tedious task and the journey may open up family dynamic and seem more an effort then you are prepared to endure.&nbsp; I encourage you to stick to the process and the end result will last for generations.</p>

                                <p><strong>Decision Tree Question: Have you shared this vision with the family (vision, mission, values)?</strong></p>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="previousStep(); showTile('2.6')">Previous</a>
                                <a class="next" @click="showTile('3.2')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('3.2')">
                        <span class="item-number">2</span>
                        <div v-if="!isOpened('3.2')" class="preview" @click="showTile('3.2')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo480427750.jpg'" alt="Introduction to Family Values ">
                            </div>
                            <div class="description">
                                <strong>Introduction to Family Values </strong> <!--Take some time to relate to the importance of values in a family business, especially during times of transition. You may know your family values, but is your family living those values everyday?-->
                            </div>
                        </div>
                        <div v-if="isOpened('3.2')" class="item-content">
                            
                            <div class="col">
                                <h2>Family Vision and Values (FFLA)</h2>
                                <iframe src="https://player.vimeo.com/video/480427750?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe>
                            </div>
                            <div class="col">
                                <h2>Driven by Values: Static and Dynamic</h2>
                                <iframe src="https://player.vimeo.com/video/150683961?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe>
                            </div>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="link"><a href="https://familyenterprise.ca/resource/our-family-values-a-shared-intention/" target="_blank">Our Family Values - A Shared Intention</a></li>
                                    <li class="link"><a href="https://familyenterprise.ca/resource/your-hierarchy-of-values/" target="_blank">Your Hierarchy of Values</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('3.1')">Previous</a>
                                <a class="next" @click="showTile('3.3')">Next</a>
                            </div>


                        </div>
                    </li>
                    <li :class="statusClass('3.3')">
                        <span class="item-number">3</span>
                        <div v-if="!isOpened('3.3')" class="preview" @click="showTile('3.3')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/camp1-1-3.3.jpg'" alt="Discuss what existing  vision/mission/values exist & which you want to honour">
                            </div>
                            <div class="description">
                                <strong>Discuss what existing  vision/mission/values exist & which you want to honour</strong> <!--Do the values and practices in your business align? Take a few minutes to note the key values in your business, and think about the corresponding practices. You may want to print this page for future reference.-->
                            </div>
                        </div>
                        <div v-if="isOpened('3.3')" class="item-content">
                           <three-circle-model model="c1p1s3t3" />

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('3.2')">Previous</a>
                                <a class="next" @click="showTile('3.4')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('3.4')">
                        <span class="item-number">4</span>
                        <div v-if="!isOpened('3.4')" class="preview" @click="showTile('3.4')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo246291412.jpg'" alt="Introduction to Family Vision">
                            </div>
                            <div class="description">
                                <strong>Introduction to Family Vision</strong> <!--Creating a shared vision from the start, can help ensure the well-being of a company in the future as it undergoes change. In a family business specifically, building a shared vision can also help protect the relationship of family members as they move toward the next generation.-->
                            </div>
                        </div>
                        <div v-if="isOpened('3.4')" class="item-content">
                            <div class="col">
                                <h2>Next Generation Leaders Creating an Inclusive Shared Vision</h2>
                                <iframe src="https://player.vimeo.com/video/246291412?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe>
                            </div>
                            <div class="col">
                                <h2>Importance of Creating a Shared Vision</h2>
                                <iframe src="https://player.vimeo.com/video/117408041?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe>
                            </div>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="link"><a href="https://familyenterprise.ca/resource/creating-a-common-vision/" target="_blank">Creating a Common Vision</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('3.3')">Previous</a>
                                <a class="next" @click="showTile('3.5')">Next</a>
                            </div>
                        </div>
                        
                    </li>
                    <!--li :class="statusClass('3.5')">
                        <span class="item-number">5</span>
                        <div v-if="!isOpened('3.5')" class="preview">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Create plan to integrate/refresh family values & vision & articluate it to all stakeholders">
                            </div>
                            <div class="description">
                                <strong>Create plan to integrate/refresh family values & vision & articluate it to all stakeholders</strong> 
                            </div>
                        </div>
                        <div v-if="isOpened('3.5')" class="item-content">
                            <p>Coming soon</p>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('3.4')">Previous</a>
                                <a class="next" @click="showTile('3.6')">Next</a>
                            </div>
                        </div>
                        
                    </li-->

                    <li :class="statusClass('3.5')">
                        <span class="item-number">5</span>
                        <div v-if="!isOpened('3.5')" class="preview" @click="showTile('3.5')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Designation of a family leader">
                            </div>
                            <div class="description">
                                <strong>Designation of a family leader</strong> <!--The Family Leader is the glue that binds the family members. Use this template to understand this role and begin applying the structure you would like to use to select your Family Leader -->
                            </div>
                        </div>
                        <div v-if="isOpened('3.5')" class="item-content">
                            <h1>The Family Leader</h1>

                            <iframe :src="baseurl + 'assets/pdf/family/The-Family-Leader.pdf'" class="pdf"></iframe>

                            <div class="additional-resources">
                                <h3>Download</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/pdf/family/The-Family-Leader.pdf'" target="_blank">Process Template</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('3.4')">Previous</a>
                                <a class="next" @click="nextStep(); showTile('4.1')">Next</a>
                            </div>
                        </div>
                        
                    </li>
                </ul>
            </div>



            <div v-if="step == 4">
                <h1 v-if="openedTile === 0">Planning the Transition of Responsibilities</h1>
                
                <ul class="progress-line">
                    <li :class="statusClass('4.1')">
                        <span class="item-number">1</span>
                        <div v-if="!isOpened('4.1')" class="preview" @click="showTile('4.1')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo90767503.jpg'" alt="Create guidelines for confidentiality">
                            </div>
                            <div class="description">
                                <strong>Create guidelines for confidentiality</strong> <!--A Family Code of Conduct is a written set of guidelines, rules or expectations that govern the behaviour of family members, usually during Family Meetings. Codes commonly focus on explicit rules for harmonious communication; however, guidelines can extend into operational actions: “Make decisions together without drawing in third parties.” Variations include Sibling Code of Conduct.-->
                            </div>
                        </div>
                        <div v-if="isOpened('4.1')" class="item-content">
                            <div class="block">
                                
                                <h1>Developing a Code of Conduct for Business Family Members</h1>
                                <div class="res-author">Anthony Basile, Joseph Basile, Bill Reilly</div>
                                <div class="res-date">Published: May 1, 2014</div>
                                
                                <p>Watch the Basiles, a third generation business family with employees in the fourth generation, who own and operate Catania Spagna in the USA, describe ways by which they have created a ‘family discipline’ at work in order to function harmoniously when focusing on the business together. Creating expectations and guidelines that apply to both family and non-family members can help make an equal and cohesive work environment, contributing to the success of the family business.</p>

                                <iframe src="https://player.vimeo.com/video/90767503?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe>

                                <div class="additional-resources">
                                    <h3>Additional Resources</h3>
                                    <ul>
                                        <li class="link"><a href="https://www.familybusinessmagazine.com/codes-conduct-bring-families-together-listen-1" target="_blank">Codes of conduct bring families together to listen</a></li>
                                        <li class="pdf"><a :href="baseurl + 'assets/pdf/family/Code-of-Conduct.pdf'" target="_blank">Code of Conduct Template</a></li>
                                    </ul>
                                </div>

                                <div :class="'nav nav'+path">
                                    <a class="previous" @click="previousStep(); showTile('3.5')">Previous</a>
                                    <a class="next" @click="showTile('4.2')">Next</a>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('4.2')">
                        <span class="item-number">2</span>
                        <div v-if="!isOpened('4.2')" class="preview" @click="showTile('4.2')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/pingouins.jpg'" alt="Develop eligibilty requirements for family members entering the business">
                            </div>
                            <div class="description">
                                <strong>Develop eligibilty requirements for family members entering the business</strong> <!--If you own a family business, you’ve no doubt had new family members come knocking on your door to ask for a job. When that happens, how do you determine whether hiring this relative would be a good decision for the business? It might be wise to consider some “rules of entry” for new family members-->
                            </div>
                        </div>
                        <div v-if="isOpened('4.2')" class="item-content">
                            <h1></h1>

                            <a href="https://hbr.org/2020/01/how-to-decide-who-can-join-the-family-business" target="_blank" class="play-link">
                                <span>Click here to read more</span>
                                <img :src="baseurl + 'assets/images/camp1-4.2.jpg'" alt="HBR Article" style="max-width: 80%; height: auto;">
                            </a>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('4.1')">Previous</a>
                                <a class="next" @click="showTile('4.3')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('4.3')">
                        <span class="item-number">3</span>
                        <div v-if="!isOpened('4.3')" class="preview" @click="showTile('4.3')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Address a family/work-life balance">
                            </div>
                            <div class="description">
                                <strong>Address a family/work-life balance</strong> <!--Balancing the demand of family and business is challenging but doable. Understand the risks of overemphazing one circle over the other and then begin reflecting on how you intend to mainatin that critical balance now and during your transition-->
                            </div>
                        </div>
                        <div v-if="isOpened('4.3')" class="item-content">
                            
                            <a href="https://familyenterprise.ca/resources/compass/?c=19" target="_blank" class="play-link">
                                <span>Click here to learn more</span>
                                <img :src="baseurl + 'assets/images/slide19.jpg'" alt="Slide 19" style="max-width: 80%; height: auto; margin-left: auto; margin-right: auto; display: block;">
                            </a>



                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/pdf/family/A-Balancing-Act-Template-AI.pdf'" target="_blank">WEFI Balancing Act Tempate</a></li>
                                    <li class="link"><a href="https://familyenterprise.ca/resource/juggling-rubber-balls-and-glass-balls/" target="_blank">Juggling Rubber Balls and Glass Balls</a></li>
                                </ul>
                            </div>
                            


                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('4.2')">Previous</a>
                                <a class="next" @click="showTile('4.4')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('4.4')">
                        <span class="item-number">4</span>
                        <div v-if="!isOpened('4.4')" class="preview" @click="showTile('4.4')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Begin building a plan to educate the NxG">
                            </div>
                            <div class="description">
                                <strong>Begin building a plan to educate the NxG</strong> <!--What is a family learning champion? What important role does this champion play in raising the probability that a family’s wealth can survive beyond a third generation? What can we learn from families who have learning champions? This article explores these questions and offers compelling motivations for helping our family enterprise clients think through why having a learning champion could foster many of the outcomes they ultimately seek.-->
                            </div>
                        </div>
                        <div v-if="isOpened('4.4')" class="item-content">
                            <h1>Your Learning Champion is Key to Next-Gen Creativity and Drive</h1>
                            <p>What is a family learning champion? What important role does this champion play in raising the probability that a family’s wealth can survive beyond a third generation? What can we learn from families who have learning champions? This article explores these questions and offers compelling motivations for helping our family enterprise clients think through why having a learning champion could foster many of the outcomes they ultimately seek.</p>

                            <iframe :src="baseurl + 'assets/pdf/family/Article-Find-Your-Learning-Champion-Shape-Your-Family-Purpose.pdf'" class="pdf"></iframe>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/pdf/family/Article-Find-Your-Learning-Champion-Shape-Your-Family-Purpose.pdf'" target="_blank">Your family learning champion is key to next‑gen creativity and drive</a></li>
                                    <li class="video"><a href="https://familyenterprise.ca/resource/becoming-a-learning-family-enterprise/" target="_blank">Becoming a “Learning Family Enterprise”</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('4.3')">Previous</a>
                                <a class="next" @click="showTile('4.5')">Next</a>
                            </div>
                        </div>
                        
                    </li>
                    <li :class="statusClass('4.5')">
                        <span class="item-number">5</span>
                        <div v-if="!isOpened('4.5')" class="preview" @click="showTile('4.5')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo115271438.jpg'" alt="Develop a written  convenant/charter">
                            </div>
                            <div class="description">
                                <strong>Develop a written  convenant/charter</strong> <!--A covenant agreement is akin to a contractual agreement between parties. It often outlines terms and conditions where a party will perform a certain action or refrain from performing a certain action. Covenants are legally binding and enforceable. A covenant can also refer to a similar agreement in a bond and will determine whether a party will or won't take a particular action.-->
                            </div>
                        </div>
                        <div v-if="isOpened('4.5')" class="item-content">
                            <div class="block">
                                <h1>How to Start a Family Covenant?</h1>
                                <div class="res-author">Lena Jungell</div>
                                <div class="res-date">Published: Dec 23, 2014</div>  
                                
                                <p>Listen to Lena as she explains the development of a family charter. Though developing a charter proved to be challenging, as elements of the business are constantly changing, it is important in a family business to create a project that all members can be involved in.</p>

                                <iframe src="https://player.vimeo.com/video/115271438?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe>

                            

                                <div :class="'nav nav'+path">
                                    <a class="previous" @click="showTile('4.4')">Previous</a>
                                    <a class="next" @click="nextStep(); showTile('5.1')">Next</a>
                                </div>
                            </div>
                        </div>
                        
                    </li>
                </ul>
            </div>






            <div v-if="step == 5">
                <h1 v-if="openedTile === 0">Transitioning Family Value</h1>
                
                <ul class="progress-line">
                    <li :class="statusClass('5.1')">
                        <span class="item-number">1</span>
                        <div v-if="!isOpened('5.1')" class="preview" @click="showTile('5.1')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo380016418.jpg'" alt="What is your family's competitive advantage? Focus on intangible assets (talent, relationships, social and spiritual capital)">
                            </div>
                            <div class="description">
                                <strong>What is your family's competitive advantage? Focus on intangible assets (talent, relationships, social and spiritual capital)</strong> <!--Total wealth is much more than just your financial assets. After watching and listening to these resources, begin taking stock of your families total welath, beyond the financial.-->
                            </div>
                        </div>
                        <div v-if="isOpened('5.1')" class="item-content">
                            <div class="block">

                               <h1>Explaining the Concept of Total Wealth</h1>
                               <div class="res-author">Danielle Saputo</div>
                               <div class="res-date">Published: Jan 13, 2020</div>
                               
                               <iframe src="https://player.vimeo.com/video/380016418?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe>

                                <div class="additional-resources">
                                    <h3>Additional Resources</h3>
                                    <ul>
                                        <li class="link"><a href="https://familyenterprise.ca/resource/how-family-businesses-stay-ahead-podcast/" target="_blank">How Family Businesses Stay Ahead</a></li>
                                    </ul>
                                </div>


                                <div :class="'nav nav'+path">
                                    <a class="previous" @click="previousStep(); showTile('4.5')">Previous</a>
                                    <a class="next" @click="showTile('5.2')">Next</a>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('5.2')">
                        <span class="item-number">2</span>
                        <div v-if="!isOpened('5.2')" class="preview" @click="showTile('5.2')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="What is your family's competitive advantage? Set of questions">
                            </div>
                            <div class="description">
                                <strong>What is your family's competitive advantage? Set of questions</strong> <!--As you might have suspected, the unique ingredients stem from having “family” as part of the business equation. The benefits derived from being a family in business will vary depending on the makeup and size of the family and its stage of evolution (i.e. first, second, third generation). The following are some of the benefits that differentiate family businesses and can provide a significant competitive advantage.-->
                            </div>
                        </div>
                        <div v-if="isOpened('5.2')" class="item-content">
                            <h1>Competitive Advantage</h1>

                            <a :href="baseurl + 'assets/pdf/family/Competitive-Advantage-Template-AQ.xlsx'" target="_blank" class="play-link">
                                <span>Click to download the template</span>
                                <img :src="baseurl + 'assets/images/Family-Excel-Template.jpg'" alt="Competitive Advantage" style="max-width: 80%; height: auto;">
                            </a>

                            
                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="excel"><a :href="baseurl + 'assets/pdf/family/Competitive-Advantage-Template-AQ.xlsx'" target="_blank">Competitive Advantage Template</a></li>

                                    <li class="pdf"><a href="https://familyenterprise.ca/res/pub/docs/resources/Articles/CentreforFamilyBusinessCompetitiveAdvantage.pdf" target="_blank">The Competitive Advantage of a Family Business</a></li>

                                    <li class="link"><a href="https://familybusiness.org/content/Using-family-history-for-competitive-advantage" target="_blank">Using Family History for Competitive Advantage</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('5.1')">Previous</a>
                                <a class="next" @click="showTile('5.3')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('5.3')">
                        <span class="item-number">3</span>
                        <div v-if="!isOpened('5.3')" class="preview" @click="showTile('5.3')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Build Family Trust (specify financial/legal)">
                            </div>
                            <div class="description">
                                <strong>Build Family Trust (specify financial/legal)</strong> <!--More family businesses and wealth are held in trust than ever before. Yet, despite the best efforts of advisors, trusts often fail to reach their full potential after the ink dries. It doesn’t have to be this way.-->
                            </div>
                        </div>
                        <div v-if="isOpened('5.3')" class="item-content">
                            <h1>Ten Facts Every Trust Beneficiary Should Know</h1>

                            <iframe :src="baseurl + 'assets/pdf/family/Article-Ten-facts-every-beneficiary-should-know.pdf'" class="pdf"></iframe>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/pdf/family/Article-Ten-facts-every-beneficiary-should-know.pdf'" target="_blank">Ten Facts Every Trust Beneficiary Should Know</a></li>

                                    <li class="video"><a href="https://familyenterprise.ca/resource/the-benefits-and-challenges-of-trusts/" target="_blank">The Benefits and Challenges of Trusts</a></li>

                                    <li class="video"><a href="https://familyenterprise.ca/resource/beyond-the-plan-bringing-trusts-to-life/" target="_blank">Beyond the Plan: Bringing Trusts to Life</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('5.2')">Previous</a>
                                <a class="next" @click="showTile('5.4')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('5.4')">
                        <span class="item-number">4</span>
                        <div v-if="!isOpened('5.4')" class="preview" @click="showTile('5.4')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Create family bonding experiences ( make suggestions)">
                            </div>
                            <div class="description">
                                <strong>Create family bonding experiences ( make suggestions)</strong> <!--For all the work that needs to be done to ensure a successful family transition, what must not be lost is the need to also have some fun! Use this template to begin planning some fun family activities to take some of the stress out of this process.-->
                            </div>
                        </div>
                        <div v-if="isOpened('5.4')" class="item-content">
                            
                            <h1>Planning Family Activities</h1>

                            <iframe :src="baseurl + 'assets/pdf/family/Family-Activity-Template-AS.pdf'" class="pdf"></iframe>

                            <div class="additional-resources">
                                <h3>Download</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/pdf/family/Family-Activity-Template-AS.pdf'" target="_blank">Family Activity Template</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('5.3')">Previous</a>
                                <a class="next" @click="showTile('5.5')">Next</a>
                            </div>
                        </div>
                        
                    </li>
                    <!--li :class="statusClass('5.5')">
                        <span class="item-number">5</span>
                        <div v-if="!isOpened('5.5')" class="preview">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Task force to individually interview all family members about their dreams, ambitions...">
                            </div>
                            <div class="description">
                                <strong>Task force to individually interview all family members about their dreams, ambitions...</strong> 
                            </div>
                        </div>
                        <div v-if="isOpened('5.5')" class="item-content">
                            <p>Coming soon</p>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="podcast"><a href="https://familyenterprise.ca/resource/the-secret-recipe-of-the-all-in-all-in-one-of-the-most-successful-global-family-businesses/" target="_blank">The Secret Recipe of “The All in All” in One of the Most Successful Global Family Businesses</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('5.4')">Previous</a>
                                <a class="next" @click="showTile('5.6')">Next</a>
                            </div>
                        </div>
                        
                    </li-->

                    <li :class="statusClass('5.5')">
                        <span class="item-number">5</span>
                        <div v-if="!isOpened('5.5')" class="preview" @click="showTile('5.5')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Determine the level of emotionnal ownership that exists - defining 'familyness'">
                            </div>
                            <div class="description">
                                <strong>Determine the level of emotionnal ownership that exists - defining 'familyness'</strong> <!--Did you know that the degree of emotional ownership has a major impact on family business succession? Take some time ot reflect and work on how this looks in your family -->
                            </div>
                        </div>
                        <div v-if="isOpened('5.5')" class="item-content">

                            <iframe src="https://familyenterprise.ca/resources/tut6/#introduction" class="tut"></iframe>

                            <div class="additional-resources">
                                <h3>Download</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/images/Week1_Succession_BFF-750x2643.jpg'" target="_blank">Engaging the next generation fostering emotional ownership</a></li>
                                </ul>
                            </div>


                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('5.4')">Previous</a>
                                <a class="next hide"></a>
                            </div>
                        </div>
                        
                    </li>
                </ul>
            </div>


            <!--a v-if="step > 1 && openedTile === 0" :class="'prev path' + path" @click="previousStep()">Previous</a>
            <a v-if="step < 5 && openedTile === 0" :class="'next path' + path" @click="nextStep()">Next</a-->


        </div>
    </div>
  </div>
</template>

<script>
import threeCircleModel from "@/components/three-circle-model.vue";
import whoIsFamily from "@/components/who-is-family.vue";

function setCookie(name, value, minutes) {
  var expires;
  if (minutes) {
    var date = new Date();
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

// Read cookie
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

export default {
  name: "camp1-path1",
  components: {
    threeCircleModel,
    whoIsFamily
  },
  data() {
    return {
      tile: 1,
      openedTile: 0,
      completedTiles: (getCookie("completedTiles1") ? JSON.parse(getCookie("completedTiles1")) : []),
      path: 1,
      progress1: 0,
      progress2: 0,
      progress3: 0,
      progress4: 0,
      progress5: 0,
    };
  },
  mounted() {},
  props: ["vimeoPause","vimeoPlay","vimeoGoTo","voidPath","step"],
  computed: { },
  methods: {

    statusClass(t) {
        let c = '';
        
        if (this.isCompleted(t)) {
            c = c + ' done ';
        }
        
        if (this.activeTile(t)) {
            c = c + ' active ';
        }

        return c;
    }, 

    getProgress(s) {
        let p = 0;

        switch (s) {
            case 1:
                if (this.completedTiles.includes('1.1')) { p += 17; }
                if (this.completedTiles.includes('1.2')) { p += 17; }
                if (this.completedTiles.includes('1.3')) { p += 17; }
                if (this.completedTiles.includes('1.4')) { p += 17; }
                if (this.completedTiles.includes('1.5')) { p += 17; }
                if (this.completedTiles.includes('1.6')) { p += 17; }
                if (p > 100) { p = 100; }
                this.progress1 = p;
                break;

            case 2:
                if (this.completedTiles.includes('2.1')) { p += 17; }
                if (this.completedTiles.includes('2.2')) { p += 17; }
                if (this.completedTiles.includes('2.3')) { p += 17; }
                if (this.completedTiles.includes('2.4')) { p += 17; }
                if (this.completedTiles.includes('2.5')) { p += 17; }
                if (this.completedTiles.includes('2.6')) { p += 17; }
                if (p > 100) { p = 100; }
                this.progress2 = p;
                break;

            case 3:
                if (this.completedTiles.includes('3.1')) { p += 20; }
                if (this.completedTiles.includes('3.2')) { p += 20; }
                if (this.completedTiles.includes('3.3')) { p += 20; }
                if (this.completedTiles.includes('3.4')) { p += 20; }
                if (this.completedTiles.includes('3.5')) { p += 20; }
                if (p > 100) { p = 100; }
                this.progress3 = p;
                break;

            case 4:
                if (this.completedTiles.includes('4.1')) { p += 20; }
                if (this.completedTiles.includes('4.2')) { p += 20; }
                if (this.completedTiles.includes('4.3')) { p += 20; }
                if (this.completedTiles.includes('4.4')) { p += 20; }
                if (this.completedTiles.includes('4.5')) { p += 20; }
                if (p > 100) { p = 100; }
                this.progress4 = p;
                break;

            case 5:
                if (this.completedTiles.includes('5.1')) { p += 20; }
                if (this.completedTiles.includes('5.2')) { p += 20; }
                if (this.completedTiles.includes('5.3')) { p += 20; }
                if (this.completedTiles.includes('5.4')) { p += 20; }
                if (this.completedTiles.includes('5.5')) { p += 20; }
                if (p > 100) { p = 100; }
                this.progress5 = p;
                break;
        }

        return '';
    },

    goto(s) {
        this.step = s;
        this.vimeoGoTo(1, 1, s);
    },

    nextStep() {
        this.step = this.step + 1;
        this.vimeoGoTo(1, 1, this.step);
    },

    previousStep() {
        this.step = this.step - 1;
        this.vimeoGoTo(1, 1, this.step);
    },
    

    activeTile(t) {
        if (this.tile == t) {
            return true;
        }
        return false;
    },

    showTile(t) {
        
        if (this.openedTile) {
            this.closeTile()
        }

        this.tile = t;
        this.openedTile = t;
    },

    closeTile() {
        this.completed(this.openedTile);
        this.openedTile = 0;
        this.tile = 0;
    },

    isOpened(t) {
        if (this.openedTile == t) {
            return true;
        }
        return false;
    },

    completed(t) {

        if (!this.completedTiles.includes(t)) {
            this.completedTiles.push(t);
        }

       setCookie("completedTiles1", JSON.stringify(this.completedTiles));
       
        for (var i = 1; i < 6; i++) {
            this.getProgress(i);
        }

    },

    isCompleted(t) {    
        if (this.completedTiles.includes(t)) {
            return true;
        }
        return false;
    }
  }
};
</script>

<style scoped>


</style>
